import { render } from "./StartStat.vue?vue&type=template&id=58072ace"
import script from "./StartStat.vue?vue&type=script&lang=js"
export * from "./StartStat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__